"use client";

import { ClerkProvider } from "@clerk/nextjs";
import { dark } from "@clerk/themes";
import { useTheme } from "next-themes";
import { deDE } from "@/lib/customLocalization-deDE";

export function ClerkProviderWrapper({ children }) {
  const { resolvedTheme, systemTheme } = useTheme();
  // Use systemTheme as fallback before hydration to minimize flash
  const isDark = resolvedTheme === "dark" || (!resolvedTheme && systemTheme === "dark");

  return (
    <ClerkProvider
      localization={deDE}
      afterSignOutUrl="/sign-in"
      appearance={{
        baseTheme: isDark ? dark : undefined,
        variables: {
          colorPrimary: "hsl(var(--primary))",
        },
        elements: {
          formButtonPrimary:
            "bg-primary border-primary hover:bg-primary/90 text-primary-foreground",
          membersPageInviteButton:
            "bg-primary border-primary hover:bg-primary/90 text-primary-foreground",
          footerActionLink: "text-primary hover:text-primary/80",
        },
      }}
    >
      {children}
    </ClerkProvider>
  );
}
